var SegmentsModule = /** @class */ (function () {
    function SegmentsModule() {
    }
    return SegmentsModule;
}());
export { SegmentsModule };
